<template>
	<div class="menu">
		<fluke-card>
			<header>
				<div class="title">
					Menu
				</div>
				<div class="description">
					Lista dos itens de menu
				</div>
			</header>
			<main>
				<div class="flexsplit">
					<div>
						Superior:<br/>
						<draggable class="list-group" :list="menu.top" group="people" @change="orderMenu" handle=".handle">
							<div
								class="list-group-item"
								v-for="(element, index) in menu.top"
								:key="index">

								<div class="handle_props" :class="{ handle: permission.write===true }"><i class="material-icons">reorder</i></div>

								{{ element.label }}

								<div class="actions-buttons">
									<i class="material-icons" @click="edit( 'top', index )" v-if="permission.write===true">edit</i>
									<i class="material-icons" @click="del( 'top', index )" v-if="permission.write===true">delete</i>
								</div>
							</div>
						</draggable>
					</div>
					<div>
						Inferior:<br/>
						<draggable class="list-group" :list="menu.bottom" group="people" @change="orderMenu" handle=".handle">
							<div
								class="list-group-item"
								v-for="(element, index) in menu.bottom"
								:key="index">

								<div class="handle_props" :class="{ handle: permission.write===true }"><i class="material-icons">reorder</i></div>

								{{ element.label }}

								<div class="actions-buttons">
									<i class="material-icons" @click="edit( 'bottom', index )" v-if="permission.write===true">edit</i>
									<i class="material-icons" @click="del( 'bottom', index )" v-if="permission.write===true">delete</i>
								</div>
							</div>
						</draggable>
					</div>
				</div>
			</main>
			<footer v-if="permission.write">
				<fluke-button v-on:click.native="addMenu">Adicionar Item</fluke-button>
			</footer>
		</fluke-card>

		<global-popup ref="remove" title="Remover">Deseja remover o item?</global-popup>
	</div>
</template>

<script>
import axios from 'axios';
import Card from '../../components/Main/Content/Card/Card.vue';
import Button from '../../components/Main/Content/Button/Button.vue';
import draggable from "vuedraggable";

import permission from '../../mixins/permissions';


export default {
	mixins: [ permission ],
	components: {
		'fluke-card': Card,
		'fluke-button': Button,
		draggable
	},
	data: function() {
		return {
			menu: {
				top: [],
				bottom: []
			},
			headers: [
				{
					text: "Pergunta",
					align: 'left',
					value: 'question'
				},
				{
					text: "Resposta",
					align: 'left',
					value: 'anwser'
				},
			],
			permission: {
				read: false,
				write: false
			},
		}
	},
	created: function() {
		this.getMenu();
		this.permission = this.getUserPagePermission('menu');
		if( this.permission.read == false ) {
			this.$router.push('/');
		}
	},
	methods: {
		addMenu: async function() {
			this.$router.push({ name: 'menu-add' });
		},
		orderMenu() {
			axios.put(
				this.$myServerAddresses.pages + 'pages/menu/order',
				{
					menu: JSON.stringify( this.menu )
				},
				{
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
			);
		},
		async getMenu() {
            const result = await axios.get(
				this.$myServerAddresses.pages + 'pages/menu',
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
			);
			this.menu = JSON.parse( result.data.value );
		},
		edit: function( position, index ) {
			this.$router.push({ name: 'menu-edit', params: { id: position + '-' + index } });
		},
		del( position, index ) {
			this.$refs.remove
                .confirm()
                .then(()=>{
					this.menu[ position ] = this.menu[ position ].filter( (el,idx) => idx != index );
					this.orderMenu();
				});
		}
	}
}
</script>

<style lang="scss">
.menu {
	.list-group-item {
		border: 1px solid rgba(0,0,0,.3);
		padding: 10px 5px 10px 38px;
		margin: 2px 0;
		background-color: #fff;
		position: relative;
		border-radius: 3px;


		&.sortable-chosen {
			border-width: 3px;
			border-color: $accent-color;
		}

		.handle_props {
			position: absolute;
			top: 6px;
			left: 6px;
			cursor: pointer;
		}

		.actions-buttons {
			position: absolute;
			top: 6px;
			right: 6px;
			cursor: pointer;
		}
	}
}
</style>
